/**
 * Normalizes a label for tolerant text matching: trims, lowercases, and collapses
 * internal whitespace. Used to match imported headers/emails against catalog values
 * regardless of casing or stray spaces (the export adds leading spaces to some headers).
 *
 * @param {*} value - Any cell/header value.
 * @returns {string} The normalized label ('' for null/undefined).
 */
const normalizeLabel = (value) =>
    String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');

export default normalizeLabel;
